"use client";
import React from "react";
import { Box, Container, Typography } from "@mui/material";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";

import { toKebabCase, toTitleCase } from "@/utils/helpers";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { destinationList } from "../destinations/AllDestinations";
import Image from "next/image";
import { LinkButtonV2 } from "./BestCruiseDeals";

const PopularDestinations = () => {
  return (
    <Box
      sx={{
        bgcolor: "#000F45",
        overflow: "hidden",
      }}
    >
      <Container>
        <Box sx={{ mt: "2.4rem" }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: "2.2rem", md: "3rem" },
              fontWeight: { xs: 800, md: 700 },
              textAlign: "center",
              color: "#fff",
              lineHeight: { xs: 1.1, md: 1.3 },
              mb: { xs: "10px", md: "0px" },
              span: {
                color: "transparent",
                WebkitTextStrokeColor: "#fff",
                WebkitTextStrokeWidth: "1px",
              },
            }}
          >
            Cruise Destinations Across <span>All Seven Continents</span>
          </Typography>
          <Box
            sx={{
              fontSize: { xs: "14px", md: "1rem" },
              fontWeight: 400,
              lineHeight: { xs: 1.4, md: 1.3 },
              textAlign: "center",
              mb: { xs: "1.6rem", md: "2.2rem" },
              color: "#D5D3FF",
            }}
          >
            Set sail on an adventure where you can discover fascinating Caribbean, European, Asian,
            and beyond cruise destinations at your own pace.
          </Box>
        </Box>

        <Box
          sx={{
            position: "relative",
            width: "100%",
            mb: "3rem",
            img: {
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "flex",
            },
            ".hero_swiper": {
              width: "100%",
              height: { xs: "200px", md: "300px" },
              border: "2px solid #fff",
              borderRadius: "15px",
              overflow: "hidden",
              position: "relative",
              p: "1rem",
              transition: "all 0.5s",
              "&:hover": {
                border: "2px solid #5900FF",
              },
            },
            ".swiper": {
              width: "100%",
              height: "100%",
              position: "relative",
              zIndex: 1,
              overflow: "visible",
            },
            ".swiper-button-next": {
              top: "50%",
              bgcolor: "#e30053",
              color: "#fff",
              border: "1px solid",
              borderColor: "#fff",
              boxShadow: "0px 0px 14px rgba(0,0,0,0.5)",
              p: "4px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              "&:hover": {
                bgcolor: "#fff",
                color: "#e30053",
                borderColor: "#e30053",
              },
              "&:after": {
                fontSize: "17px",
                pl: "2px",
              },
            },
            ".swiper-button-prev": {
              top: "50%",
              bgcolor: "#e30053",
              color: "#fff",
              border: "1px solid",
              borderColor: "#fff",
              boxShadow: "0px 0px 14px rgba(0,0,0,0.5)",
              p: "4px",
              width: "40px",
              height: "40px",
              borderRadius: "50%",
              "&:hover": {
                bgcolor: "#fff",
                color: "#e30053",
                borderColor: "#e30053",
              },
              "&:after": {
                fontSize: "17px",
                pr: "3px",
              },
            },
          }}
        >
          <Swiper
            modules={[Autoplay, Navigation, Pagination]}
            spaceBetween={16}
            navigation={true}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false,
            }}
            breakpoints={{
              640: {
                slidesPerView: 1.1,
                spaceBetween: 16,
              },
              600: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              900: {
                slidesPerView: 4,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            }}
          >
            {destinationList.map((data, index) => (
              <SwiperSlide key={index}>
                <Box className="hero_swiper">
                  <Image
                    src={`/images/destination-images/${toKebabCase(data.name)}-cruises.jpg`}
                    fill
                    alt={data.name}
                    sizes="(min-width: 1200px) 20vw, (min-width: 900px) 25vw, (min-width: 600px) 50vw, 90vw"
                    style={{ objectFit: "cover" }}
                  />

                  <Box
                    sx={{
                      top: { xs: "1rem", md: "1rem" },
                      left: { xs: "1rem", md: "1rem" },
                      position: "absolute",
                      zIndex: 12,
                      pointerEvents: "none",
                      color: "#fff",
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { xs: "2rem", md: "2rem" },
                        fontWeight: 900,
                        textShadow: "0px 0px 10px #55555577, 2px 2px 0px #3933E6",
                      }}
                    >
                      {toTitleCase(data.name)}
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      bottom: { xs: "1rem", md: "1rem" },
                      right: { xs: "1rem", md: "1rem" },
                      position: "absolute",
                      zIndex: 12,
                    }}
                  >
                    <LinkButtonV2
                      href={`/cruise-destinations/${toKebabCase(data.page_url)}`}
                      text={"View Destination"}
                    />
                  </Box>
                </Box>
              </SwiperSlide>
            ))}
          </Swiper>
        </Box>
      </Container>
    </Box>
  );
};

export default PopularDestinations;
